import { cn } from "@/lib/utils";

interface SectionWrapperProps {
    id?: string;
    children: React.ReactNode;
    className?: string;
    narrow?: boolean;
}

export function SectionWrapper({
    id,
    children,
    className,
    narrow,
}: SectionWrapperProps) {
    return (
        <section
            id={id}
            className={cn(
                "relative py-(--section-y) px-6 md:px-8",
                className
            )}
        >
            <div
                className={cn(
                    "mx-auto w-full",
                    narrow ? "max-w-3xl" : "max-w-6xl"
                )}
            >
                {children}
            </div>
        </section>
    );
}

interface SectionEyebrowProps {
    children: React.ReactNode;
    className?: string;
}

export function SectionEyebrow({ children, className }: SectionEyebrowProps) {
    return (
        <p
            className={cn(
                "text-xs font-semibold uppercase tracking-[0.2em] text-mars mb-4",
                className
            )}
        >
            {children}
        </p>
    );
}

interface SectionHeadlineProps {
    children: React.ReactNode;
    className?: string;
}

export function SectionHeadline({ children, className }: SectionHeadlineProps) {
    return (
        <h2
            className={cn(
                "text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight leading-[1.1] text-text mb-6",
                className
            )}
        >
            {children}
        </h2>
    );
}
